// LanguageExposureContext.tsx
"use client";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import { getProfiles } from "@/features/profiles/server/actions/getProfiles";
import { Profile } from "@/data/profiles/profiles-schema";
interface ProfilesContextType {
  profiles: Profile[];
  getProfile: (profileId: string) => Promise<Profile | undefined>;
}

const ProfilesContext = createContext<ProfilesContextType | undefined>(
  undefined,
);

export const ProfilesProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [profiles, setProfiles] = useState<Profile[]>([]);

  const getProfilesData = async () => {
    const allProfiles = await getProfiles();
    setProfiles(allProfiles);
    return allProfiles;
  };

  useEffect(() => {
    getProfilesData();
  }, []);

  const getProfile = useCallback(
    async (profileId: string) => {
      const allProfiles = await getProfiles();
      return (
        allProfiles &&
        allProfiles.find(
          (p) =>
            p?.profileId?.trim()?.toLocaleLowerCase() ===
            profileId?.trim()?.toLocaleLowerCase(),
        )
      );
    },
    [profiles, getProfiles],
  );

  return (
    <ProfilesContext.Provider
      value={{
        profiles,
        getProfile,
      }}
    >
      {/* Dont do this. Send empty and show empty state on component level */}
      {children}
    </ProfilesContext.Provider>
  );
};

export const useProfiles = () => {
  const context = useContext(ProfilesContext);
  if (!context) throw new Error("Must be used within ProfilesProvider");
  return context;
};
